import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm, formPropTypes, Field } from 'redux-form';
import {
  Row,
  Col,
  FormGroup,
  Button,
} from 'react-bootstrap';

import { DateField } from '../../fields/index';
import DistrictFilter from '../../fields/DistrictFilter';
import DepartmentFilter from '../../fields/DepartmentFilter';
import PerDiemLegend from '../components/PerDiemLegend';
import PerDiemDatePickerEnhanced from './PerDiemDatePickerEnhanced';

import { setDepartment, setDistrict, setEndDate } from '../actions';
import { getDepartment, getDistrict, getEndDateInputFormat } from '../selectors';
import { createRenderer } from '../../reduxForm/utils';

const FORM_NAME = 'PerDiemReportFilteringForm';

const propTypes = exact({
  endDate: PropTypes.string,
  district: PropTypes.object,
  department: PropTypes.object,
  initialValues: PropTypes.object,
  setDistrictAction: PropTypes.func.isRequired,
  setEndDateAction: PropTypes.func.isRequired,
  setDepartmentAction: PropTypes.func.isRequired,

  validate: PropTypes.func.isRequired,
  ...formPropTypes,
});

const validate = (values) => {
  const errors = [];

  const { endDate, district } = values;

  if (!endDate) {
    errors.endDate = 'Required';
  }
  if (!district) {
    errors.district = 'Required';
  }
  return errors;
};

const RenderDistrict = createRenderer((input, label, { district }) => {
  return (
    <DistrictFilter hideNoneOption value={district} {...input} />
  );
});

const RenderDepartment = createRenderer((input, label, { department }) => {
  return (
    <DepartmentFilter hideNoneOption value={department} {...input} />
  );
});


const FilteringPanel = (props) => {
  const formSubmit = (values) => {
    const { setDistrictAction, setEndDateAction, setDepartmentAction } = props;
    const { endDate, district, department } = values;

    setDistrictAction(district);
    setDepartmentAction(department);
    setEndDateAction(new Date(endDate).toISOString());
  };

  const { handleSubmit, submitting, invalid, pristine } = props;
  const { district, department } = props;

  return (
    <React.Fragment>
      <form onSubmit={handleSubmit(formSubmit)}>
        <Row>
          <Col md={9}>
            <FormGroup>
              <DateField
                name="endDate"
                label="End Date"
              />
            </FormGroup>
          </Col>
          <Col md={3}>
            <FormGroup>
              <label />
              <div style={{ marginTop: '11px' }}>
                <PerDiemDatePickerEnhanced />
              </div>
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                district={district}
                name="district"
                type="select"
                label="District"
                format={null}
                component={RenderDistrict}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup>
              <Field
                department={department}
                name="department"
                type="select"
                label="Department"
                format={null}
                component={RenderDepartment}
              />
            </FormGroup>
          </Col>
        </Row>
        <Button
          bsStyle="primary"
          type="submit"
          disabled={(submitting || pristine || invalid)}
        >
          Submit
        </Button>
      </form>
      <hr />
      <div>
        <PerDiemLegend />
      </div>
    </React.Fragment>
  );
};


FilteringPanel.propTypes = propTypes;
FilteringPanel.defaultProps = {
  initialValues: {},
};

const withForm = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
  validate,
});

const mapStateToProps = (state) => {
  return {
    endDate: getEndDateInputFormat(state),
    district: getDistrict(state),
    department: getDepartment(state),
  };
};


const mapDispatchToProps = {
  setEndDateAction: setEndDate,
  setDistrictAction: setDistrict,
  setDepartmentAction: setDepartment,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRedux,
  withForm,
);

export default enhance(FilteringPanel);
